import { CompetenceActivityClass, ProgramData, ProgressCheck } from "@interfaces/Interfaces";
import { useProgramData } from "@hooks/data/useProgramData";

export const useLearningLoop = () => {
  const { userPrograms } = useProgramData();

  const checkIfProgramHasLearningLoop = (program: ProgramData): boolean => {
    if (program.CompetenceActivity?.length) {
      const competencesWithLearningLoop = program.CompetenceActivity.filter((competence) => competence.LearningLoop);

      return competencesWithLearningLoop.length > 0;
    }

    if (program.ProgressChecks?.length) {
      const allCompetences = program.ProgressChecks.flatMap((progressCheck) => progressCheck["Competence/Activity"]);

      const competencesWithLearningLoop = allCompetences.filter((competence) => competence.LearningLoop);

      return competencesWithLearningLoop.length > 0;
    }

    return false;
  };

  const getProgressCheckWithLearningLoop = (program: ProgramData): ProgressCheck | undefined => {
    if (program.ProgressChecks?.length) {
      const progressCheck = program.ProgressChecks.find((progressCheck) => {
        const competences = progressCheck["Competence/Activity"];

        return competences.filter((competence) => competence.LearningLoop).length > 0;
      });

      return progressCheck;
    }
  };

  const getCompetenceWithLearningLoop = (program: ProgramData): CompetenceActivityClass | undefined => {
    if (program.CompetenceActivity?.length) {
      return program.CompetenceActivity.find((competence) => competence.LearningLoop);
    }

    if (program.ProgressChecks?.length) {
      const allCompetences = program.ProgressChecks.flatMap((progressCheck) => progressCheck["Competence/Activity"]);

      return allCompetences.find((competence) => competence.LearningLoop);
    }
  };

  const getProgramsWithLearningLoop = () => {
    return userPrograms.filter((program) => checkIfProgramHasLearningLoop(program));
  };

  const hasLearningLoop = userPrograms.some((program) => checkIfProgramHasLearningLoop(program));

  return {
    hasLearningLoop,
    getProgramsWithLearningLoop,
    getProgressCheckWithLearningLoop,
    getCompetenceWithLearningLoop,
    programsWithLearningLoop: getProgramsWithLearningLoop(),
  };
};
